import anscombes_quartet_thumb from "../image/anscombes_quartet_thumb.png";
import different_scatter_variables_thumb from "../image/different_scatter_variables_thumb.png";
import errorband_lineplots_thumb from "../image/errorband_lineplots_thumb.png";
import faceted_histogram_thumb from "../image/faceted_histogram_thumb.png";
import faceted_lineplot_thumb from "../image/faceted_lineplot_thumb.png";
import grouped_barplot_thumb from "../image/grouped_barplot_thumb.png";
import grouped_boxplot_thumb from "../image/grouped_boxplot_thumb.png";
import grouped_violinplots_thumb from "../image/grouped_violinplots_thumb.png";
import heat_scatter_thumb from "../image/heat_scatter_thumb.png";
import hexbin_marginals_thumb from "../image/hexbin_marginals_thumb.png";
import histogram_stacked_thumb from "../image/histogram_stacked_thumb.png";
import horizontal_boxplot_thumb from "../image/horizontal_boxplot_thumb.png";
import jitter_stripplot_thumb from "../image/jitter_stripplot_thumb.png";
import joint_histogram_thumb from "../image/joint_histogram_thumb.png";
import joint_kde_thumb from "../image/joint_kde_thumb.png";
import kde_ridgeplot_thumb from "../image/kde_ridgeplot_thumb.png";
import large_distributions_thumb from "../image/large_distributions_thumb.png";
import layered_bivariate_plot_thumb from "../image/layered_bivariate_plot_thumb.png";
import logistic_regression_thumb from "../image/logistic_regression_thumb.png";
import multiple_conditional_kde_thumb from "../image/multiple_conditional_kde_thumb.png";
import wide_data_lineplot_thumb from "../image/wide_data_lineplot_thumb.png";
import timeseries_facets_thumb from "../image/timeseries_facets_thumb.png";
import structured_heatmap_thumb from "../image/structured_heatmap_thumb.png";
import spreadsheet_heatmap_thumb from "../image/spreadsheet_heatmap_thumb.png";
import scatterplot_sizes_thumb from "../image/scatterplot_sizes_thumb.png";
import scatterplot_matrix_thumb from "../image/scatterplot_matrix_thumb.png";
import multiple_regression_thumb from "../image/multiple_regression_thumb.png";


export const visualisationTypes = [{name: 'multiple regression thumb', image:multiple_regression_thumb}, 
{name: 'scatterplot matrix thumb', image:scatterplot_matrix_thumb},
{name: 'scatterplot sizes thumb', image:scatterplot_sizes_thumb},
{name: 'spreadsheet heatmap thumb', image:spreadsheet_heatmap_thumb},
{name: 'structured heatmap thumb', image:structured_heatmap_thumb},
{name: 'timeseries facets thumb', image:timeseries_facets_thumb},
{name: 'wide data lineplot thumb', image:wide_data_lineplot_thumb},
{name: 'multiple conditional kde thumb', image:multiple_conditional_kde_thumb},
{name: 'logistic regression thumb', image:logistic_regression_thumb},
{name: 'layered bivariate plot thumb', image:layered_bivariate_plot_thumb},
{name: 'large distributions thumb', image:large_distributions_thumb},
{name: 'kde ridgeplot thumb', image:kde_ridgeplot_thumb},
{name: 'joint kde thumb', image:joint_kde_thumb},
{name: 'joint histogram thumb', image:joint_histogram_thumb},
{name: 'jitter stripplot thumb', image:jitter_stripplot_thumb},
{name: 'horizontal boxplot thumb', image:horizontal_boxplot_thumb}, 
{name: 'histogram stacked thumb', image:histogram_stacked_thumb},
{name: 'hexbin marginals thumb', image:hexbin_marginals_thumb},
{name: 'heat scatter thumb', image:heat_scatter_thumb},
{name: 'grouped violinplots thumb', image:grouped_violinplots_thumb},
{name: 'grouped boxplot thumb', image:grouped_boxplot_thumb},
{name: 'grouped barplot thumb', image:grouped_barplot_thumb},
{name: 'faceted lineplot thumb', image:faceted_lineplot_thumb},
{name: 'faceted histogram thumb', image:faceted_histogram_thumb},
{name: 'errorband lineplots thumb', image:errorband_lineplots_thumb},

{name: 'different scatter variables thumb', image:different_scatter_variables_thumb},
{name: 'anscombes quartet thumb', image:anscombes_quartet_thumb},


]
















